module.exports = __webpack_public_path__ + "static/media/.env.22cf6c05.bin";